import { render } from "./ModalProductStock.vue?vue&type=template&id=176c311a"
import script from "./ModalProductStock.vue?vue&type=script&lang=js"
export * from "./ModalProductStock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__